import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function ServerIcon(props: ACIconProps) {
  return <ACIconWrapper {...props} component={IconSvg} />;
}

const IconSvg = () => {
  return (
    <svg
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_6939_2248)">
        <path
          d="M16.25 5V10M16.25 14V19M5.75 10.25H18.25C18.8023 10.25 19.25 9.80228 19.25 9.25V5.75C19.25 5.19772 18.8023 4.75 18.25 4.75H5.75C5.19772 4.75 4.75 5.19772 4.75 5.75V9.25C4.75 9.80228 5.19771 10.25 5.75 10.25ZM5.75 19.25H18.25C18.8023 19.25 19.25 18.8023 19.25 18.25V14.75C19.25 14.1977 18.8023 13.75 18.25 13.75H5.75C5.19772 13.75 4.75 14.1977 4.75 14.75V18.25C4.75 18.8023 5.19771 19.25 5.75 19.25Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6939_2248">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
